import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-image-slider' })
export class ImageSlider {
	constructor(private element: HTMLElement) {
		const instance = new Swiper(element, {
			slidesPerView: 1,
			spaceBetween: 0,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			breakpoints: {
				992: {
					slidesPerView: 'auto'
				}
			}
		});
	}
}
